module.exports = __webpack_public_path__ + "img/logo-lg-medium.864964a3.svg";